import type React from 'react';

import { Chip } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const SectionChips: React.FC<{
	section: string;
	setSection: React.Dispatch<React.SetStateAction<'stories' | 'posts'>>;
	showStories: boolean;
	showPosts: boolean;
}> = ({ section, setSection, showStories, showPosts }) => {
	return (
		<div className="mb-6 flex flex-row gap-3" data-testid="share-visuals-chips" data-qa="share-visuals-chips">
			{showStories && (
				<Chip
					data-testid="stories-chip"
					data-qa="stories-chip"
					as="button"
					size="small"
					onClick={() => setSection('stories')}
					active={section === 'stories'}
					data-active={section === 'stories' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">
						<Translate value="corgi.petition.starter_dashboard_v2.shared.share_visuals.stories_chip" />
					</div>
				</Chip>
			)}
			{showPosts && (
				<Chip
					data-testid="posts-chip"
					data-qa="posts-chip"
					as="button"
					size="small"
					onClick={() => setSection('posts')}
					active={section === 'posts'}
					data-active={section === 'posts' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">
						<Translate value="corgi.petition.starter_dashboard_v2.shared.share_visuals.posts_chip" />
					</div>
				</Chip>
			)}
		</div>
	);
};
